import React from 'react'
import { Icon, Header, Field, Switch } from '../index'
import './feature3.css'

/**
 * ToggleIcon
 */
const ToggleIcon = ({ open = false , onChange }) => {
  const iconName = !open ? 'keyboard_arrow_left' : 'keyboard_arrow_right'
  const state = open ? 'open' : 'closed'
  return <Icon className={`feature-toggle-icon ${state}`} icon={iconName} clickable action={onChange} />
}

/**
 * FeatureBox
 */
class FeatureBox extends React.Component {

  state = {
    edit: false
  }

  toggleMode = () => {
    const edit = !this.state.edit
    this.setState({ edit })
  }

  onChange = (id, value) => {
    this.toggleMode()
  }

  renderEditor = () => {
    const  { id, children } = this.props
    const editor = React.cloneElement( children, { id, onChange: this.onChange })
    return editor
  }

  render() {
    const { icon, label, value, readonly, children } = this.props
    return (
      <Header icon={{icon}} title={label} className="feature3">
        { readonly ? '' : <ToggleIcon open={this.state.edit} onChange={this.toggleMode}/> }
        { this.state.edit ? this.renderEditor() : <label>{value}</label>}
      </Header>
    )
  }
}

/**
 * Feature3
 */
const Feature3 = (props) => {

  const editor = () => {
    switch(props.type) {
      case "NUMBER":
        return <Field {...props} type="number"/>
      case "STRING":
        return <Field {...props} />
      case "BOOLEAN":
        return <Switch {...props} />
      default:
        return <div> No editor for type {props.type}</div>
    }
  }

  return (
    <FeatureBox {...props}>
      {editor()}
    </FeatureBox>
  )
}

export { FeatureBox, Feature3 }



// WEBPACK FOOTER //
// ./src/lib/components/feature3.js